import parent from './api/parent'
export default {
    findMyAccount (req) {
        return parent.pms_post('api/admin/store/user/findMyAccount',req)
    },
    videoPlayInfo(req) {
        return parent.pms_post('api/vod/video/playInfo',req)
    },
    initializeDeviceId(req) {
        return parent.pms_post('api/store/dealerModule/initializeDeviceId',req)
    },
    getVersion(req) {
        return parent.pms_get('api/version/appversion',req)
    },

}
